import script from "./supplierPage.vue?vue&type=script&setup=true&lang=js"
export * from "./supplierPage.vue?vue&type=script&setup=true&lang=js"

import "./supplierPage.vue?vue&type=style&index=0&id=1caa5978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1caa5978"]])

export default __exports__